module.exports = __webpack_public_path__ + "static/media/cross-black.ab9012a3.svg";